import { SEARCH_SECTION_FROM } from "@faire/help-center-utils/consts/eventEnum";

export const useIsSearchInputAtHeader = (
  sectionFrom?: SEARCH_SECTION_FROM
): boolean => {
  if (!sectionFrom) {
    return false;
  }
  return (
    sectionFrom === SEARCH_SECTION_FROM.NAV_SEARCH_HEADER ||
    sectionFrom === SEARCH_SECTION_FROM.NAV_SEARCH_SEARCH_RESULT_ABOVE ||
    sectionFrom === SEARCH_SECTION_FROM.NAV_SEARCH_TOPICS_ABOVE ||
    sectionFrom === SEARCH_SECTION_FROM.NAV_SEARCH_ARTICLE_ABOVE ||
    sectionFrom === SEARCH_SECTION_FROM.NAV_SEARCH_POPULAR_GUIDES_ABOVE
  );
};
